import styled from 'styled-components';

export const Wrapper = styled.div`
  border-radius: 16px;
  background-size: contain;
  padding: 2rem;
  max-width: 350px;
  min-width: 350px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.01) 100%);

  &:hover {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.08) 100%);
  }
  
`;

export const Title = styled.div`
  font-size: 1.3rem;
  font-family: ${({ theme }) => theme.fontFamily.medium};
  color: ${({ theme }) => theme.colors.white};
`;

export const Description = styled.p`
  font-family: ${({ theme }) => theme.fontFamily.regular};
  line-height: 170%;
  flex-grow: 1;
`;

export const Link = styled.a`
  width: 100%;
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
  display: flex;
  align-items: center;
  margin-top: 24px;
  justify-content: space-between;
  /* border: 1px solid #9f8fcb;
  background-color: ${({ theme }) => theme.colors.background};
  transition: 0.2s ease background-color;
  &:hover,
  &:active {
    background-color: #15132d;
  } */
`;

export const LinkText = styled.div`
  font-size: 12px;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
`;

export const Icon = styled.img`
  /* font-size: 12px;
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white}; */
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
`;

export const AuraImage = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
`;